import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(() => import("../../components/AuthenticationPages/forgotPassword"));

const ForgotPassword = () => {
  return (
      <Suspense fallback={<CircularLoader />}>
        <Main />
      </Suspense>
  );
};

export default ForgotPassword;

